// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadbrumb-module--breadcrumb--16HKf","separator":"breadbrumb-module--separator--2-1g7","page":"breadbrumb-module--page--20HxW"};